export function checkEmail(text) {
    const pattern = /^[\w\.-]+@[\w\.-]+\.\w+$/ //eslint-disable-line
  
    if (pattern.test(text)) return true
    return false
}